import { render, staticRenderFns } from "./PlaceItem.vue?vue&type=template&id=64bde666&scoped=true"
import script from "./PlaceItem.vue?vue&type=script&lang=js"
export * from "./PlaceItem.vue?vue&type=script&lang=js"
import style0 from "./PlaceItem.vue?vue&type=style&index=0&id=64bde666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bde666",
  null
  
)

export default component.exports